module.exports = __webpack_public_path__ + "static/img/1.d2ab2605.png";